import React from "react";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/core/styles";
import {
  Button,
  showNotification as shn,
  fetchStart as fs,
  fetchEnd as fe,
} from "react-admin";

import { pauseMultipleKiosks } from "../lib/serverCommands";

const handleClick = (
  selectedIds,
  { showNotification, fetchStart, fetchEnd }
) => {
  fetchStart();
  pauseMultipleKiosks({ selectedIds })
    .then(() => showNotification("notification.endOfSell"))
    .catch(err => {
      showNotification("notification.errorSending");
      console.error("Error sending multiple pause kiosk message", err);
    })
    .finally(fetchEnd);
};

const BulkPauseButton = ({ selectedIds, ...props }) => (
  <Button label="Pause" onClick={() => handleClick(selectedIds, props)} />
);

const styles = () => ({
  container: {
    display: "flex",
  },
});

export default connect(
  null,
  {
    showNotification: shn,
    fetchStart: fs,
    fetchEnd: fe,
  }
)(withStyles(styles)(BulkPauseButton));



// WEBPACK FOOTER //
// ./src/components/bulkPauseButton.js